/* Version: 3.5.149 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var arrowKeysUnselected = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsxs("g", {
      fillRule: "nonzero",
      children: [/*#__PURE__*/jsx("path", {
        style: {
          fill: '#C2C3C9'
        },
        d: "M7.08 6.137v1.92h-.001l.001 3.84H5.16l-.001-3.84H1.32v-1.92h5.76z",
        transform: "translate(-544 -234) translate(350 218) translate(194 16) rotate(-180 8.1 9.3) rotate(135 4.2 9.017)"
      }), /*#__PURE__*/jsx("path", {
        style: {
          fill: '#C2C3C9'
        },
        d: "M7.08 7.073H5.16l-.001-3.841H1.32v-1.92h5.76v5.76z",
        transform: "translate(-544 -234) translate(350 218) translate(194 16) rotate(-180 8.1 9.3) rotate(-45 4.2 4.193)"
      })]
    })]
  });
});

export { arrowKeysUnselected as default };
